import { Box, Stack, Typography, Grid, Chip, Button } from "@mui/material";
import { Link } from "react-router-dom";
import Header from "../../../components/Header";
import VILLAS from "./constants";

const Villas = () => {
  return (
    <Box
      maxWidth={1100}
      mx="auto"
      pt={{ xs: 8, sm: 12 }}
      pb={{ xs: 0, sm: 12 }}
      mb={12}
      id="villas"
      px={{ xs: 2, sm: 4 }}
    >
      <Header
        label="Our Stays"
        title="Premium vacation rental Villas in North Goa"
      />
      <Box>
        <Grid
          container
          mt={{ xs: 0, sm: 4 }}
          spacing={4}
          columns={{ xs: 4, md: 12 }}
        >
          {VILLAS.map((elem, idx) => (
            <Grid item xs={4}>
              <Link
                to={elem.comingSoon ? "/" : elem.link}
                style={{ textDecoration: "none" }}
              >
                <Box
                  data-aos="fade-up"
                  data-aos-delay={idx * 100}
                  sx={{
                    overflow: "hidden",
                    cursor: "pointer",
                    position: "relative",
                  }}
                >
                  {elem.comingSoon && (
                    <Chip
                      label="Coming soon"
                      color="white"
                      sx={{ position: "absolute", right: 12, top: 12 }}
                    />
                  )}
                  <picture>
                    <source srcSet={`${elem.img}.webp`} type="image/webp" />
                    <img
                      width="100%"
                      style={{ borderRadius: 24 }}
                      src={`${elem.img}.jpg`}
                      alt={elem.title}
                    />
                  </picture>
                  <Stack mt={2}>
                    <Typography variant="h5">{elem.title}</Typography>
                    <Typography variant="body1" color="text.secondary">
                      {elem.description}
                    </Typography>
                  </Stack>
                </Box>
              </Link>
            </Grid>
          ))}
        </Grid>

        {/* View All Villas Button */}
        <Box textAlign="center" mt={{ xs: 4, sm: 8 }}>
          <Link to="/villas" style={{ textDecoration: "none" }}>
            <Button
              variant="outlined"
              color="white"
              size="large"
              sx={{
                px: 6,
                py: 1.5,
                borderColor: "#ffffff50",
                fontSize: "1.1rem",
                fontWeight: 600,
                borderRadius: 100,
                "&:hover": {
                  bgcolor: "rgba(255, 255, 255, 0.1)",
                  borderColor: "#fff",
                },
              }}
            >
              View All Villas
            </Button>
          </Link>
        </Box>
      </Box>
    </Box>
  );
};

export default Villas;
